import React from "react";
import { BendaharaSPP } from "@/pages/bendahara/BendaharaSPP";
import { NAV_KEPSEK } from "@/lib/nav";

export function ListSPP() {
  // Kepsek: full read + download, no Input/Edit/Delete.
  return <BendaharaSPP nav={NAV_KEPSEK} canEdit downloadOnly pageTitle="Data Pembayaran SPP" />;
}
